<template>
  <div class="requisition-documents-container">
    <div class="mb-3">
      <em class="icon-shadowed fas fa-laptop text-orange" />
      <span class="color-gray-7 font-16 font-weight-bold ml-2 mb-2">
        Equipos Requisados
      </span>
    </div>
    <div class="mt-4" v-for="(item, key) in item.detail" :key="key">
      <custom-callout
        class="rounded mb-4 mb-4 custom-callout rounded"
        border-color="green2"
        :controlled="false"
      >
        <div class="row ">
          <div class="col-12 col-md-12">
            <div class="row py-3 m-0">
              <div class="col-md-3 col-12 col-spacing">
                <div class="color-secondary-6 font-14 font-weight-normal mr-2">
                  Equipo:
                </div>
                <div class="color-black font-16 font-weight-bold">
                  {{ item.equipmentName | empty }}
                </div>
              </div>
              <div class="col-md-4 col-12 col-spacing mt-2 mt-md-0">
                <div class="color-secondary-6 font-14 font-weight-normal mr-2">
                  Articulo de SIFDE:
                </div>
                <div class="color-black font-16 font-weight-bold">
                  {{ item.sifdeEquipment | empty }}
                </div>
              </div>
              <div class="col-md-3 col-12 col-spacing mt-2 mt-md-0">
                <div class="color-secondary-6 font-14 font-weight-normal mr-2">
                  Tipo de Requisición:
                </div>
                <div class="color-black font-16 font-weight-bold">
                  {{ requisitionType(item) }}
                </div>
              </div>
              <div class="col-md-2 col-12 col-spacing mt-2 mt-md-0">
                <div class="color-secondary-6 font-14 font-weight-normal mr-2">
                  Cantidad:
                </div>
                <div class="color-black font-16 font-weight-bold">
                  {{ item.quantity | currency }}
                </div>
              </div>
            </div>
            <div class="row py-md-3 m-0">
              <div class="col-lg-3 col-12">
                <div class="color-secondary-6 font-14 font-weight-normal mr-2">
                  Unidad de Medida:
                </div>
                <div class="color-black font-16 font-weight-bold">
                  {{ item.unit | empty }}
                </div>
              </div>
              <div class="col-lg-4 col-12 mt-2 mt-md-0">
                <div class="color-secondary-6 font-14 font-weight-normal mr-2">
                  Precio:
                </div>
                <div class="color-black font-16 font-weight-bold">
                  {{ item.price | price }}
                </div>
              </div>
              <div class="col-lg-3 col-12 mt-2 mt-md-0">
                <div class="color-secondary-6 font-14 font-weight-normal mr-2">
                  Cifra de Cuenta:
                </div>
                <div class="color-black font-16 font-weight-bold">
                  {{ item.purchaseOrderNumber | empty }}
                </div>
              </div>
              <div class="col-lg-2 col-12 mt-2 mt-md-0">
                <div class="color-secondary-6 font-14 font-weight-normal mr-2">
                  Tipo de Cifra:
                </div>
                <div class="color-black font-16 font-weight-bold">
                  {{ item.isFederal | empty }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <template #edition>
          <div class="bg-light-gray p-2">
            <div class="bg-white pb-3 rounded">
              <requisition-row-tabs
                :item="item"
                :tab-index="0"
                :description="item.description"
                @onTabChanged="onTabChanged"
              />
            </div>
          </div>
        </template>
      </custom-callout>
    </div>
  </div>
</template>

<script>
import CustomCallout from 'custom-callout';
import Checkbox from 'CheckBox';
import IconView from 'icon-view';

import RequisitionRowTabs from './RequisitionRowTabs';
export default {
  name: 'RequisitionEquipments',
  components: {
    CustomCallout,
    Checkbox,
    IconView,
    RequisitionRowTabs,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    tabIndex: 0,
    checked: true,
  }),
  computed: {
    requisitionType() {
      return (item) =>
        item.isSIFDERegular
          ? 'Regular'
          : item.isSIFDEAunction
          ? 'Subasta'
          : '-';
    },
  },
  methods: {
    onTabChanged(index) {
      this.tabIndex = index;
    },
  },
};
</script>
<style lang="scss" scoped></style>
